<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div class="subtitle-1 primary--text">
            {{ issue }}
          </div>
        </div>
        <div>
          <div>
            <v-row>
              <v-col md="12">
                <v-card outlined>
                  <div class="d-flex">
                    <v-col>
                      <div>
                        Fecha de creación:
                      </div>
                      <div class="pl-2">
                        {{ createdAt | toDate }}
                      </div>
                    </v-col>
                    <v-divider vertical />
                    <v-col>
                      <div>
                        Tipo:
                      </div>
                      <div class="pl-2">
                        {{ type }}
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div>
                        Restaurante:
                      </div>
                      <div class="pl-2">
                        {{ restaurant }}
                      </div>
                    </v-col>
                  </div>
                </v-card>
              </v-col>
              <v-col md="12">
                <v-card outlined>
                  <v-card-title>
                    Mensajes
                  </v-card-title>
                  <v-card-text>
                    <div v-for="(message, index) in messages" :key="`message-${index}`">
                      <div v-if="message.restaurant">
                        <div>
                          {{ message.restaurant }}
                        </div>
                        <div>
                          {{ message.text }}
                        </div>
                      </div>
                      <div v-else>
                        <div>
                          Tú
                        </div>
                        <div>
                          {{ message.text }}
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-end">
                      <v-btn
                        color="secondary"
                        rounded
                        small
                        @click="closed">
                        Cerrar Reclamación
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="12">
                <div class="d-flex">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="message"/>
                    <v-btn
                      color="primary"
                      rounded
                      small
                      @click="answer">
                      Enviar
                      <v-icon small>mdi-send</v-icon>
                    </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>

    </v-navigation-drawer>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: 'IssueDetail',
  props: {
    issue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      statuses: {
        'open': 'Nueva orden',
        'in-progress': 'Confirmada',
        'closed': 'Cancelada',
        'reopen': 'Facturada'
      },
      id: '',
      createdAt: '',
      type: '',
      restaurant: '',
      messages: '',
      message: ''
    }
  },
  watch: {
    async issue (id) {
      await this.load(id)
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.isOpen = false
    },
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    },
    async load (id) {
      this.id = id
      try {
        const response = await this.$api.get(`/v1/issue/${this.id}/detail`)
        this.type = response.type
        this.restaurant = response.restaurant.name
        this.createdAt = response.createdAt
        this.messages = response.messages.map(item => {
          return (item.author !== this.$store.state.login.user._id) ? { ...item, restaurant: this.restaurant } : item
        })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    async answer () {
      try {
        await this.$api.post(`/v1/issue/${this.id}/answer`, { text: this.message })
        this.message = ''
        await this.load(this.id)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    async closed () {
      try {
        await this.$api.put(`/v1/issue/${this.id}/close`, { text: this.message })
        this.message = ''
        this.$toasted.show('Reclamación cerrada', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    }
  }
}
</script>
